import TaTransactionTable from './TaTransactionTable'

export default TaTransactionTable
